export function validatePhone(phone: string) {
  var regex = /^1[3456789]\d{9}$/;
  return regex.test(phone);
}
// 密码登录用：国内手机号，或带 + 区号的海外手机号
export function validateLoginPhone(phone: string) {
  const p = phone.trim();
  if (p.startsWith('+')) {
    return p.length > 6;
  }
  return /^1[3456789]\d{9}$/.test(p);
}
export function validateEmail(email: string) {
  email = email.trim();
  const regex = /^[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
}
